import { render, staticRenderFns } from "./newsInfoDetail.vue?vue&type=template&id=38b5c230&scoped=true"
import script from "./newsInfoDetail.vue?vue&type=script&lang=ts"
export * from "./newsInfoDetail.vue?vue&type=script&lang=ts"
import style0 from "./newsInfoDetail.vue?vue&type=style&index=0&id=38b5c230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5c230",
  null
  
)

export default component.exports